import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { updateConstantDetailFetchSuccess, updateConstantDetailFetchFailure } from './reducer';
import { ConstantDetailResType } from 'src/types/constantsCodeDetail';
import translate from '@translate';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { formatFromCodes } from './functions';

const updateConstantDetailFetchRequest = async (params: { constantKey: string; data: ConstantsCodeType[] }) => {
    const res = await api(
        'put',
        `api/secure/constants/${params.constantKey}`,
        formatFromCodes(params.data, params.constantKey)
    );
    return res.data;
};

function* updateConstantDetailFetch(action: {
    type: string;
    payload: { constantKey: string; data: ConstantsCodeType[] };
}) {
    try {
        const response: ConstantDetailResType = yield call((): any => updateConstantDetailFetchRequest(action.payload));
        yield put(
            updateConstantDetailFetchSuccess({
                ...response,
                constantKey: action.payload.constantKey,
                messageSuccess: { title: translate('constants.message.constantUpdate') },
            })
        );
    } catch (error) {
        yield put(updateConstantDetailFetchFailure({ error }));
    }
}

export function* updateConstantDetailFetchWatch() {
    yield takeEvery('constantsCodes/updateConstantDetailFetch', updateConstantDetailFetch);
}
